// src/section/mainsite/PosterHero.tsx
import { motion } from "framer-motion";
import poster1 from "../../assets/images/Cover.webp";

type PosterHeroProps = {
  loading: boolean;
  hidden?: boolean;
};

function PosterHero({ loading, hidden = false }: PosterHeroProps) {
  if (hidden) return null; // ✅ Eltűnik, amint a Hero betöltött

  return (
    <section
      id="section-hero-placeholder"
      style={{
        width: "100%",
        height: "100dvh", // vagy calc(var(--vh, 1vh) * 100) ha biztosra mész
        backgroundColor: "#000",
        position: "relative",
        zIndex: 1,
      }}
    >
      <img
        src={poster1}
        alt="Poster background"
        loading="eager"
        decoding="async"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />

      <motion.h1
        initial={{ clipPath: "inset(0 100% 0 0)" }}
        animate={{ clipPath: "inset(0 0% 0 0)" }}
        transition={{ duration: 1, ease: "easeInOut" }}
        style={{
          zIndex: 2,
          position: "absolute",
          top: "6rem",
          color: "#fff",
          fontSize: "3.5rem",
          fontFamily: "'Two Weekends Sans', sans-serif",
          textAlign: "center",
          width: "100%",
        }}
      >
        F*** it! – The First Rehydration Drink for Sex by Rouse
      </motion.h1>

      <motion.h2
        animate={
          loading ? { opacity: [1, 0.1, 1] } : { opacity: 1 }
        }
        transition={
          loading
            ? { duration: 1.2, repeat: Infinity, ease: "easeInOut" }
            : { duration: 0.4 }
        }
        style={{
          zIndex: 2,
          position: "absolute",
          bottom: "6rem",
          color: "#fff",
          fontSize: "3.5rem",
          fontFamily: "'Two Weekends Sans', sans-serif",
          textAlign: "center",
          width: "100%",
          padding: "0 1rem",
        }}
      >
        Hydrate... Sex... Keep loading...
      </motion.h2>
    </section>
  );
}

export default PosterHero;
